import { render, staticRenderFns } from "./Repeater.vue?vue&type=template&id=1fb771b9"
import script from "./Repeater.vue?vue&type=script&lang=ts"
export * from "./Repeater.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports